import styled from 'styled-components';

export const ReportRadioBox = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
`;


export const ReportButton = styled.div`
  & i {
    color: #aaa;
    transition: color 200ms linear;
  }
  &:hover i {
    color: #333 !important;
  }
`;

export const ReportMenu = styled.div`
  position: absolute;
  right: 0px;
  z-index: 999;
  font-size: 12px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px; 
  width: 110px;
`;

export const SingleReport = styled.div`
  padding: 5px;
  &:hover {
    background: #ccc;
  }
`;